export const DESIGNER_EVENTS = {
  PACKAGE_NAME_EDIT: 'designer.package.name.edit',
  PACKAGE_NAME_SAVE: 'designer.package.name.save',
  PACKAGE_WORKSPACE_CHANGE: 'designer.package.workspace.change',
  PACKAGE_RUN_JOB: 'designer.package.run.job',
  PACKAGE_RUN_JOB_DISABLE: 'designer.package.run.job.disable',
  PACKAGE_RESIZE: 'designer.package.resize',
  PACKAGE_SCROLL: 'designer.package.scroll',
  PACKAGE_UPDATED: 'designer.package.updated',
  PACKAGE_UPDATE_VERSION: 'designer.package.update.version',
  PACKAGE_UPDATE_DATA: 'designer.package.update.data',
  PACKAGE_SAVED: 'designer.package.saved',
  PACKAGE_SELECTION_CHANGE: 'designer.package.selection.change',
  PACKAGE_VARIABLES_EDIT: 'designer.package.variables.edit',
  PACKAGE_VARIABLES_UPDATE: 'designer.package.variables.update',
  PACKAGE_VARIABLES_ADD: 'designer.package.variables.add',
  PACKAGE_VARIABLES_REMOVE: 'designer.package.variables.remove',
  PACKAGE_VALIDATION_LOADING: 'designer.package.validation.loading',
  PACKAGE_VALIDATION_DISABLED: 'designer.package.validation.disabled',
  PACKAGE_VALIDATION_VERSION: 'designer.package.validation.version',
  WORKSPACE_EDIT: 'designer.workspace.edit',
  COMPONENT_ADD: 'designer.component.add',
  COMPONENT_MENU: 'designer.component.menu',
  COMPONENT_EDIT: 'designer.component.edit',
  COMPONENT_REMOVE: 'designer.component.remove',
  COMPONENT_DRAG: 'designer.component.drag',
  COMPONENT_SELECTION_CHANGED: 'designer.component.selection.changed',
  COMPONENT_SELECTED_DRAG: 'designer.component.selected.drag',
  COMPONENT_SELECTED_DRAG_STOP: 'designer.component.selected.drag.stop',
  COMPONENT_POSITION_CHANGE: 'designer.component.position.change',
  COMPONENT_OFFSET_CHANGE: 'designer.component.offset.change',
  COMPONENT_GET_PARENT_SCHEMA: 'designer.component.get.parent.schema',
  COMPONENT_RETURN_PARENT_SCHEMA: 'designer.component.return.parent.schema',
  CONTEXT_MENU_SHOW: 'designer.context.menu.show',
  CONTEXT_MENU_HIDE: 'designer.context.menu.hide',
  CREATED: 'designer.created',
  EDGE_ADD: 'designer.edge.add',
  EDGE_REMOVE: 'designer.edge.remove',
  EDGE_CONNECTOR_ADD: 'designer.edge.connector.add',
  EDGE_CONNECTOR_REMOVE: 'designer.edge.connector.remove',
  EDGE_CONNECTOR_TARGET_OVER: 'designer.edge.connector.target.over',
  EDGE_CONNECTOR_TARGET_OUT: 'designer.edge.connector.target.out',
  NOTE_EDIT: 'designer.note.edit',
  NOTE_REMOVE: 'designer.note.remove',
  HISTORY_CHANGE: 'designer.history.change',
  TERMINAL: 'designer.terminal',
  TERMINAL_FOCUS: 'designer.terminal.focus',
  RESIZE: 'designer.resize',
  SAVE: 'designer.save',
  VALIDATE: 'designer.validate',
  REVALIDATE: 'designer.revalidate',
};
